import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  h3.title-page {
    font-size: 24px;
    font-weight: 500;
  }
`;
